import * as React from 'react';

import { TextBoxTheme } from '../../enums';
import { highlightTextFragments, toMarkdown } from '../../utils';
import { Button } from '../button/button.component';

import {
  BottomSection,
  Container,
  Header,
  HeaderSection,
  TopOverlayMask,
  CircleBackgroundItem,
  StyledTextBox,
  StyledAddToFavouriteBadge,
  ButtonContainer,
  BottomSectionWrapper
} from './highlightSection.styled';
import { HighlightSectionProps } from './highlightSection.types';
import CircleBackgroundItemFile from './images/circle.svg';

export const HighlightSection: React.FC<HighlightSectionProps> = (props: HighlightSectionProps) => {
  const {
    header,
    backgroundImage,
    buttonSettings,
    description,
    favouriteBadgeDetails,
    className,
    withCircleBackground = true,
  }: HighlightSectionProps = props;

  return (
    <Container className={className} $backgroundImage={backgroundImage}>
      <TopOverlayMask />
      {withCircleBackground && <CircleBackgroundItem src={CircleBackgroundItemFile} alt='' />}
      <HeaderSection>
        <Header
          data-testid='header'
          dangerouslySetInnerHTML={{
            __html: toMarkdown(highlightTextFragments(header ?? ''))
          }}
        />
        {!!buttonSettings && !!buttonSettings.label && (
          <ButtonContainer {...buttonSettings}>
            <Button label={buttonSettings.label} />
          </ButtonContainer>
        )}
      </HeaderSection>
      {(description || favouriteBadgeDetails) && (
        <BottomSection>
          <BottomSectionWrapper>
            {favouriteBadgeDetails && <StyledAddToFavouriteBadge {...favouriteBadgeDetails} />}
            {description && <StyledTextBox textBoxTheme={TextBoxTheme.Transparent} content={description} />}
          </BottomSectionWrapper>
        </BottomSection>
      )}
    </Container>
  );
};
